module.exports = __webpack_public_path__ + "static/media/about_abtest.a6f65d23.png";